import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { schedulingV4RescheduleAppointment } from '@/api/generated/sdk.gen';
import type { RescheduleAppointmentResponse } from '@/api/generated/types.gen';
import type { TelehealthContactType } from '@/lib/constants';

type RescheduleAppointmentBaseRequest = {
  appointmentTypeId: string;
  appointmentDate: string;
  providerId: string;
  contactType: TelehealthContactType;
};

interface RescheduleAppointmentWithIdRequest extends RescheduleAppointmentBaseRequest {
  appointmentId: string;
}

interface RescheduleAppointmentWithoutIdRequest extends RescheduleAppointmentBaseRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export function useRescheduleAppointmentMutation(
  options?: UseMutationOptions<
    RescheduleAppointmentResponse,
    Error,
    RescheduleAppointmentWithIdRequest | RescheduleAppointmentWithoutIdRequest
  >
) {
  return useMutation({
    mutationFn: async (params) => {
      const base = {
        appointment_type_id: params.appointmentTypeId,
        appointment_date: params.appointmentDate,
        provider_id: params.providerId,
        contact_type: params.contactType,
      };

      const body =
        'appointmentId' in params
          ? { ...base, appointment_id: params.appointmentId }
          : {
              ...base,
              first: params.firstName,
              last: params.lastName,
              email: params.email,
              phone_number: params.phoneNumber,
            };

      const { data } = await schedulingV4RescheduleAppointment({ body });
      return data;
    },
    ...options,
  });
}
